import { render, staticRenderFns } from "./SelecionaPlayers.vue?vue&type=template&id=04267531"
import script from "./SelecionaPlayers.vue?vue&type=script&lang=js"
export * from "./SelecionaPlayers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports